import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { ThemeProvider } from './theme/ThemeProvider';
import { CopyProvider } from './theme/CopyProvider';
import './styles/global.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root element missing from index.html.');

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <ThemeProvider>
      <CopyProvider>
        <App />
      </CopyProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
